var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-textarea',{staticClass:"pt-1",staticStyle:{"max-height":"250px","overflow-y":"auto"},attrs:{"label":"Text/HTML eingeben...","rows":"2","auto-grow":"","outlined":"","hide-details":"","dense":""},model:{value:(_vm.element.text),callback:function ($$v) {_vm.$set(_vm.element, "text", $$v)},expression:"element.text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }